import { render, staticRenderFns } from "./DesktopNavigationEntry.vue?vue&type=template&id=23f9b230&scoped=true"
import script from "./DesktopNavigationEntry.vue?vue&type=script&lang=js"
export * from "./DesktopNavigationEntry.vue?vue&type=script&lang=js"
import style0 from "./DesktopNavigationEntry.scss?vue&type=style&index=0&id=23f9b230&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f9b230",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HybridLink: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/HybridLink/HybridLink.vue').default})
